import { isKeysEnabled } from '@/actions-permission/keys.permissions'
import { affiliationSettingsEnabled } from '@/actions-permission/affiliations-settings.permissions'

import {
  isSettingsAccountEnabled,
  isSettingsFeesEnabled
} from '@/actions-permission/settings-account.permission'
import { isSettingsGatewaysEnabled } from '@/actions-permission/settings-gateways.permission'
import { isSettingsPaymentsEnabled } from '@/actions-permission/settings-payments.permission'
import { isSettingsWebhooksConfigEnabled } from '@/actions-permission/settings-webhooks-config.permission'
import {
  isSettingsFunctionalitiesEnabled,
  isSettingsRecurrenceEnabled,
  isSettingsOrderConfigEnabled,
  isSettingsSectionEnabled
} from '@/actions-permission/settings.permissions'

const SETTINGS = ({
  permissionIsEnabled,
  componentIsEnabled,
  getters,
  routeName
}) => {
  return {
    key: 'settings',
    label: 'sidemenu.settings',
    showSection: isSettingsSectionEnabled(
      permissionIsEnabled,
      componentIsEnabled
    ),
    items: {
      affiliations: {
        label: 'sidemenu.submenu.settings.affiliations',
        showItem: affiliationSettingsEnabled(
          permissionIsEnabled,
          getters.businessModel,
          getters.isTestAccount
        ),
        active: routeName === 'affiliations'
      },
      'account-config': {
        label: 'sidemenu.submenu.settings.account-settings',
        showItem: isSettingsAccountEnabled(permissionIsEnabled),
        active: routeName === 'account-config'
      },
      keys: {
        label: 'sidemenu.submenu.settings.keys',
        showItem: isKeysEnabled(permissionIsEnabled),
        active: routeName === 'keys'
      },
      gateways: {
        label: 'sidemenu.submenu.settings.gateways',
        showItem: isSettingsGatewaysEnabled(permissionIsEnabled),
        active: routeName === 'gateways'
      },
      fees: {
        label: 'sidemenu.submenu.settings.fees',
        showItem: isSettingsFeesEnabled(
          permissionIsEnabled,
          getters.businessModel,
          getters.account.account_type.value
        ),
        active: routeName === 'fees'
      },
      'payment-methods': {
        label: 'sidemenu.submenu.settings.payment-methods',
        showItem: isSettingsPaymentsEnabled(permissionIsEnabled),
        active: routeName === 'payment-methods'
      },
      functionalities: {
        label: 'sidemenu.submenu.settings.functionalities',
        showItem: isSettingsFunctionalitiesEnabled(permissionIsEnabled),
        active: routeName === 'functionalities'
      },
      recurrence: {
        label: 'sidemenu.submenu.settings.recurrence',
        showItem: isSettingsRecurrenceEnabled(permissionIsEnabled),
        active: routeName === 'recurrence'
      },
      'order-config': {
        label: 'sidemenu.submenu.settings.order-settings',
        showItem: isSettingsOrderConfigEnabled(permissionIsEnabled),
        active: routeName === 'order-config'
      },
      'webhook-config': {
        label: 'sidemenu.submenu.settings.webhook-settings',
        showItem: isSettingsWebhooksConfigEnabled(
          permissionIsEnabled,
          componentIsEnabled
        ),
        active:
          routeName === 'webhook-config' || routeName === 'webhook-config-form'
      }
    }
  }
}

export default SETTINGS
